import SFetch from '@app/utils/sfetch'
import { SfLog } from '@app/adapters/logger'
import type { DocumentPreviewParts } from './types'

// Errors are logged and swallowed (returns undefined) so callers can degrade to
// an empty preview rather than throw.
export async function getDocumentPreviewParts(
  documentId: number
): Promise<DocumentPreviewParts | null | undefined> {
  const path = window.Silverfin.Routes.document_preview_parts_path(
    window.Silverfin.currentFirmId,
    window.Silverfin.currentCompanyId,
    { document_id: documentId }
  )

  try {
    return await SFetch.json<DocumentPreviewParts>(path)
  } catch (error) {
    SfLog.error('Error fetching document preview parts:', { error })
    return
  }
}
